import { Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBarsStaggered,
  faHandsHelping,
  faLayerGroup,
  faQrcode,
  faQuestion,
  faUser,
  faUsersGear,
  faBook,
} from "@fortawesome/free-solid-svg-icons";
import { MainMenuNavItem } from "./MainMenuNavItem";
import { RoutePaths } from "../RoutePaths";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { CrewInformationUb } from "../gql/graphql";
import { useCrewsQuery } from "../crew/useCrewsQuery";
import { HomeLocalStorageKeys } from "../HomeLocalStorageKeys";
import { useStateWithLocalStoragePersistenceAndDefault } from "../common/hooks/useStateWithLocalStoragePersistenceAndDefault";

interface Props {
  isMainMenuOpen: boolean;
  setIsMainMenuOpen: (
    value: ((prevState: boolean) => boolean) | boolean,
  ) => void;
}

export default function MainMenu({ isMainMenuOpen, setIsMainMenuOpen }: Props) {
  const { t } = useTranslation();

  const [currentCrewIdentifier] = useStateWithLocalStoragePersistenceAndDefault<
    string | undefined
  >(HomeLocalStorageKeys.currentCrewIdentifierKey, undefined);

  const { crews } = useCrewsQuery();
  const [currentCrewMaybe, setCurrentCrewMaybe] = useState<
    CrewInformationUb | undefined
  >(undefined);

  useEffect(() => {
    const currentCrew = crews?.find(
      (c) => c.identifier === currentCrewIdentifier,
    );
    setCurrentCrewMaybe(currentCrew);
  }, [crews, currentCrewIdentifier, isMainMenuOpen]);

  return (
    <Offcanvas
      className="bg-body-tertiary"
      isOpen={isMainMenuOpen}
      toggle={() => setIsMainMenuOpen(!isMainMenuOpen)}
    >
      <OffcanvasHeader toggle={() => setIsMainMenuOpen(!isMainMenuOpen)}>
        <Link
          to="/"
          className="text-decoration-none link-dark link-underline-opacity-50-hover"
          onClick={() => setIsMainMenuOpen(false)}
        >
          <FontAwesomeIcon icon={faLayerGroup} /> Songship
        </Link>
      </OffcanvasHeader>
      <OffcanvasBody className="d-flex flex-column flex-shrink-0 p-3">
        <ul className="nav nav-pills flex-column mb-auto">
          <MainMenuNavItem
            icon={faBarsStaggered}
            text={t("menu.playlists")}
            to={"/"}
          />
          <MainMenuNavItem
            icon={faQrcode}
            text={t("menu.scanQrCode")}
            to={`/${RoutePaths.SCAN_QR_CODE}`}
          />
          <li className="border-top my-3"></li>
          <MainMenuNavItem
            icon={faUsersGear}
            text={t("menu.manageCrews")}
            to={`/${RoutePaths.MANAGE_CREWS}`}
          />
          {currentCrewMaybe && (
            <MainMenuNavItem
              icon={faBook}
              text={t("menu.manageSongbooks")}
              to={RoutePaths.toSongbooks(currentCrewMaybe.bucket)}
            />
          )}
          <li className="border-top my-3"></li>
        </ul>
        <hr />
        <ul className="nav nav-pills flex-column">
          <MainMenuNavItem
            icon={faUser}
            text={t("menu.profile")}
            to={`/${RoutePaths.PROFILE}`}
          />
          <MainMenuNavItem
            icon={faQuestion}
            text={t("menu.help")}
            to={`/${RoutePaths.HELP}`}
          />
          <MainMenuNavItem
            icon={faHandsHelping}
            text={t("menu.infoContact")}
            to={`/${RoutePaths.INFO_CONTACT}`}
          />
        </ul>
      </OffcanvasBody>
    </Offcanvas>
  );
}
